module.exports = __webpack_public_path__ + "img/label_member@2x.df8f624c.png";